<template>

  <SetTag
    :class="{'box-loading': loading}"
    type="candidate"
    :enable="permissions.includes('manage_candidates')"
    :dark="true"
    :value="candidate.tags"
    @input="updateTags" />

</template>

<script>
import SetTag from '@/components/Fields/SetTag'

export default {
  name: 'CandidateTag',
  components: {
    SetTag
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
  },
  methods: {
    /*
    updateTags
    */
    updateTags (tags) {
      this.loading = true
      this.$store.dispatch('updateCandidate', {
        _id: this.candidate._id,
        tags: tags
      })
      .then(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateTag.vue